import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONOS = [{
  num: '01',
  title: 'Guía Rápida para Interpretar una Carta Natal en 15 Minutos',
  desc: 'Método práctico para realizar lecturas rápidas y organizadas.'
}, {
  num: '02',
  title: 'Diccionario Práctico de los 12 Signos',
  desc: 'Guía de consulta rápida para interpretar cualquier signo en segundos.'
}, {
  num: '03',
  title: '50 Preguntas Poderosas para Consultas Astrológicas',
  desc: 'Herramientas para profundizar interpretaciones y generar autoconocimiento.'
}, {
  num: '04',
  title: 'Plantillas Profesionales de Informes Astrológicos',
  desc: 'Modelos listos para organizar y entregar lecturas profesionales.'
}];
export function BenefitsSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0e1f] py-5 md:py-10 px-5 sm:px-6 border-t border-[#ffffff]/5" data-id="element-26">
      <div className="container mx-auto max-w-5xl" data-id="element-27">
        <div ref={ref1} className={`reveal text-center mb-6 ${vis1 ? 'is-visible' : ''}`} data-id="element-28">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6]" data-id="element-29">
            Además accedés a{' '}
            <span className="text-[#d4af37] italic" data-id="element-30">4 bonos exclusivos</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-31">
          {BONOS.map((bono, i) => {
          const [ref, vis] = useReveal();
          return <div key={i} ref={ref} className={`reveal bg-[#1a1f3d] border border-[#d4af37]/15 rounded-xl p-6 transition-all hover:border-[#d4af37]/40 hover:shadow-md ${vis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 60}ms`
          }} data-id="element-32">
                <div className="text-[#d4af37] font-serif font-bold text-3xl mb-3 leading-none" data-id="element-33">
                  {bono.num}
                </div>
                <h3 className="text-[#f5f1e6] font-serif font-bold text-lg mb-2 leading-tight" data-id="element-34">
                  {bono.title}
                </h3>
                <p className="text-[#cbd0e0] text-sm leading-relaxed" data-id="element-35">
                  {bono.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}